var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88574 10.8656L0.5 7.17061L9.88574 3.47559L19.2715 7.17061L9.88574 10.8656Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0043 11.5572L15.2999 9.48242V14.2247C13.6203 15.0941 11.7629 15.5486 9.88578 15.5486C8.00863 15.5486 6.15123 15.0941 4.47168 14.2247V9.48242L9.76722 11.5572C9.80673 11.567 9.84627 11.573 9.88578 11.573C9.92529 11.573 9.96482 11.567 10.0043 11.5572Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1642 13.4416C19.3815 13.659 19.5001 13.9554 19.5001 14.2518V16.1882C19.5001 16.366 19.3618 16.5241 19.1642 16.5241H17.5241C17.3463 16.5241 17.1882 16.3858 17.1882 16.1882V14.2518C17.1882 13.9554 17.3068 13.659 17.5241 13.4416C17.2475 13.165 17.1289 12.7501 17.2277 12.3549C17.3265 11.9597 17.6032 11.6435 17.9984 11.525V7.35574L18.6899 7.0791V11.525C19.0654 11.6435 19.3618 11.9597 19.4606 12.3549C19.5594 12.7501 19.4408 13.165 19.1642 13.4416Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearn);
export default __webpack_public_path__ + "static/media/learn.cd9e0ffe910a26cca6b9a5aeb731abeb.svg";
export { ForwardRef as ReactComponent };